export default from './login-button';



// WEBPACK FOOTER //
// ./app/components/login-button/index.js